import PropTypes from 'prop-types';

import commonStrings from 'modules/common/strings';

import {
  SearchSectionWrapper,
  SearchBarWrapper,
  SearchBarInput,
  SearchBarIcon,
} from './SearchBar.style';

const SearchBar = ({ searchQuery, handleSearchBarInputChange, testId }) => (
  <SearchSectionWrapper>
    <SearchBarWrapper>
      <SearchBarIcon />
      <SearchBarInput
        placeholder={commonStrings.searchBar.searchBarPlaceholder}
        value={searchQuery}
        onChange={event => handleSearchBarInputChange(event)}
        data-testid={testId}
      />
    </SearchBarWrapper>
  </SearchSectionWrapper>
);

SearchBar.propTypes = {
  searchQuery: PropTypes.string.isRequired,
  handleSearchBarInputChange: PropTypes.func.isRequired,
  testId: PropTypes.string,
};

SearchBar.defaultProps = {
  testId: '',
};

export default SearchBar;
